import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_FEMALE, STR_IMAGE, STR_MALE } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdAttachFile, MdLocationPin } from "react-icons/md";
import { GiTalk } from "react-icons/gi";
import { IoChatbubble, IoChatbubblesOutline } from "react-icons/io5";

export default function View({ data }) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [participantData, setParticipantData] = useState(null);
  const [latestMessage, setLatestMessage] = useState("");


  function getParticipantData() {
    if (data && data.participantsInfo) {
      for (const _participant of JSON.parse(data.participantsInfo)) {
        if (Number(_participant.userId) !== Number(appContext.currentUserData.id)) {
          setParticipantData(_participant);
        }
      }
    }
  }

  function getLatestMessage() {
    if (data) {
      const _messages = JSON.parse(data.messages);
      if (_messages.length > 0) {
        const _lastMessage = _messages[_messages.length - 1];


        if (_lastMessage.messageBody && _lastMessage.messageBody.trim().length > 0) {
          setLatestMessage(_lastMessage.messageBody);
        } else if(_lastMessage.messageAttachment) {
          setLatestMessage(<><MdAttachFile size={20}/> {STR_IMAGE[appContext.language]}</>)
        }
      }

    }
  }

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'chatroom',
      extraItem: participantData.userId,
    })
  }

  useEffect(() => {
    getParticipantData();
    getLatestMessage();
  }, [data])
  return (
    <div className="card" onClick={view}>
      <div className="card-body">
        <div className="d-flex">
          <IoChatbubblesOutline
            size={40}
            style={{
              flexShrink: "0",
            }}
            className="text-muted"
          />

          <div
            className=""
            id="messageDiv"
            style={{
              flexGrow: "1",
              paddingLeft: "10px",
              maxWidth: "100%", // Ensure it doesn't exceed the container width
              overflow: "hidden", // Hide overflow if any content exceeds the width
              whiteSpace: "nowrap", // Keep text on one line
              textOverflow: "ellipsis" // Add ellipsis if the content overflows
            }}
          >
            <h6
              className="font-semi-bold mNoMargin text-secondary"
              style={{
                fontSize: "18px",
                textTransform: "capitalize",
              }}
            >
              {participantData?.username}
            </h6>
            <h6
              className="mNoMargin mOneLineText"
              style={{
                fontSize: "14px",
              }}
            >
              {latestMessage}
            </h6>
            <h6
              className="font-light text-end mNoMargin pt-3"
              style={{
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              {formatDate(data.lastUpdated)}
            </h6>
          </div>
        </div>
      </div>
    </div>
  )
}
